//@ts-check
import getFileName from './getFileName';
/**
 * @type {import("./types").getFileCaptionType}
 */

export default function getFileCaptionType(path) {
  var fileName = getFileName(path);
  if (!fileName) return fileName;
  return fileName.split('.')[0];
}